
import { mapGetters } from 'vuex'
import headerAppMobile from '~/components/header-app-mobile.vue'
import headerApp from '~/components/header-app.vue'
import floatComponents from '~/components/float-components.vue'
import cartAside from '~/components/cart-aside.vue'
import footerApp from '~/components/footer-app.vue'
import modalSearch from '~/components/modals/modal-search.vue'
import popupAge from '@/components/modals/popup-age'
import loading from '~/components/loading.vue'
import * as shoppingCartLS from '@/lib/shoppingCartLS'

export default {
  name: 'Default',
  components: {
    headerAppMobile,
    headerApp,
    floatComponents,
    cartAside,
    footerApp,
    modalSearch,
    loading,
    popupAge,
  },
  data() {
    return {
      age_modal: null,
    }
  },
  async fetch() {
    try {
      this.$store.commit('isLoading', true)
      const layoutData = await this.$store.dispatch('apis/getLayoutFooter')
      if (layoutData?.content?.age_modal) {
        this.age_modal = layoutData.content.age_modal
      }
      this.$store.commit('layoutData', layoutData)
    } catch (error) {
      console.error('Error fetching layout data:', error)
    } finally {
      this.$store.commit('isLoading', false)
    }
  },
  computed: {
    ...mapGetters(['isLoading']),
  },
  async mounted() {
    this.$store.commit('float/setFloatHelp', true)
    this.$store.commit('float/setSocialShare', null)

    const locale = this.$cookies.get('locale')
    if (locale) {
      localStorage.setItem('localeLanguage', locale)
    } else {
      localStorage.setItem('localeLanguage', this.$i18n.locale)
    }

    try {
      this.$store.commit('isLoading', true)
      const cartId = shoppingCartLS.getCartId()
      if (!cartId) {
        const _cartId = await this.$store.dispatch('cart/getCartId')
        shoppingCartLS.setCartId(_cartId.data.id)
        shoppingCartLS.setProducts([])
        return
      }

      const data = await this.$store.dispatch('cart/getContent', cartId)
      shoppingCartLS.setProducts(data.data.items)
      this.$bus.$emit('reload')
    } catch (error) {
      console.error('Error loading cart:', error)
    } finally {
      this.$store.commit('isLoading', false)
    }
  },
}
